import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Card,
  Image,
  CardBody,
  Heading,
  Stack,
  Divider,
  CardFooter,
  useBreakpointValue,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";
import LanguageTag from "./WorkPages/LanguageTag";
import { FaPlus, FaMinus } from "react-icons/fa";
import { openStdin } from "process";
import { trackOrSetValue } from "@testing-library/user-event/dist/types/document/trackValue";

interface ResumeProps {
  position: string;
  employer: string;
  year: string;
  description: string[];
}

export default function ResumeItem(props: ResumeProps) {
  const alwaysOpen = true;
  const [open, setOpen] = useState<boolean | undefined>(alwaysOpen);
  return (
    <Flex
      flexDir="column"
      width="100%"
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Button
        borderBottom={
          open || alwaysOpen ? "grey solid 1px" : "lightgrey solid 1px"
        }
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={{ base: "wrap", lg: "nowrap" }}
        borderRadius={"0"}
        m="0"
        p="0"
        background="transparent"
        onClick={(c) => {
          if (!alwaysOpen) {
            setOpen(!open);
          }
        }}
      >
        <Text
          variant={open || alwaysOpen ? "typeItalic" : "type"}
          textTransform={"none"}
          color="lightgrey"
          fontWeight={"bold"}
        >
          {props.position}
        </Text>
        <Text variant="typeItalic" textTransform={"none"} color="mediumgrey">
          {props.employer}, {props.year}
        </Text>
      </Button>
      <Flex
        px="2rem"
        py="1rem"
        display={open ? "flex" : "none"}
        maxWidth="100%"
      >
        <Text variant="type" color="lightblue">
          <UnorderedList>
            {props.description.map((d) => (
              <ListItem>{d}</ListItem>
            ))}
          </UnorderedList>
        </Text>
      </Flex>
    </Flex>
  );
}
